import { __assign, __extends } from "tslib";
import { STSServiceException as __BaseException } from "./STSServiceException";
export var AssumedRoleUser;
(function (AssumedRoleUser) {
    AssumedRoleUser.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssumedRoleUser || (AssumedRoleUser = {}));
export var PolicyDescriptorType;
(function (PolicyDescriptorType) {
    PolicyDescriptorType.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PolicyDescriptorType || (PolicyDescriptorType = {}));
export var Tag;
(function (Tag) {
    Tag.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Tag || (Tag = {}));
export var AssumeRoleRequest;
(function (AssumeRoleRequest) {
    AssumeRoleRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssumeRoleRequest || (AssumeRoleRequest = {}));
export var Credentials;
(function (Credentials) {
    Credentials.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Credentials || (Credentials = {}));
export var AssumeRoleResponse;
(function (AssumeRoleResponse) {
    AssumeRoleResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssumeRoleResponse || (AssumeRoleResponse = {}));
var ExpiredTokenException = (function (_super) {
    __extends(ExpiredTokenException, _super);
    function ExpiredTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "ExpiredTokenException", $fault: "client" }, opts)) || this;
        _this.name = "ExpiredTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ExpiredTokenException.prototype);
        return _this;
    }
    return ExpiredTokenException;
}(__BaseException));
export { ExpiredTokenException };
var MalformedPolicyDocumentException = (function (_super) {
    __extends(MalformedPolicyDocumentException, _super);
    function MalformedPolicyDocumentException(opts) {
        var _this = _super.call(this, __assign({ name: "MalformedPolicyDocumentException", $fault: "client" }, opts)) || this;
        _this.name = "MalformedPolicyDocumentException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MalformedPolicyDocumentException.prototype);
        return _this;
    }
    return MalformedPolicyDocumentException;
}(__BaseException));
export { MalformedPolicyDocumentException };
var PackedPolicyTooLargeException = (function (_super) {
    __extends(PackedPolicyTooLargeException, _super);
    function PackedPolicyTooLargeException(opts) {
        var _this = _super.call(this, __assign({ name: "PackedPolicyTooLargeException", $fault: "client" }, opts)) || this;
        _this.name = "PackedPolicyTooLargeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, PackedPolicyTooLargeException.prototype);
        return _this;
    }
    return PackedPolicyTooLargeException;
}(__BaseException));
export { PackedPolicyTooLargeException };
var RegionDisabledException = (function (_super) {
    __extends(RegionDisabledException, _super);
    function RegionDisabledException(opts) {
        var _this = _super.call(this, __assign({ name: "RegionDisabledException", $fault: "client" }, opts)) || this;
        _this.name = "RegionDisabledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, RegionDisabledException.prototype);
        return _this;
    }
    return RegionDisabledException;
}(__BaseException));
export { RegionDisabledException };
export var AssumeRoleWithSAMLRequest;
(function (AssumeRoleWithSAMLRequest) {
    AssumeRoleWithSAMLRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssumeRoleWithSAMLRequest || (AssumeRoleWithSAMLRequest = {}));
export var AssumeRoleWithSAMLResponse;
(function (AssumeRoleWithSAMLResponse) {
    AssumeRoleWithSAMLResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssumeRoleWithSAMLResponse || (AssumeRoleWithSAMLResponse = {}));
var IDPRejectedClaimException = (function (_super) {
    __extends(IDPRejectedClaimException, _super);
    function IDPRejectedClaimException(opts) {
        var _this = _super.call(this, __assign({ name: "IDPRejectedClaimException", $fault: "client" }, opts)) || this;
        _this.name = "IDPRejectedClaimException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, IDPRejectedClaimException.prototype);
        return _this;
    }
    return IDPRejectedClaimException;
}(__BaseException));
export { IDPRejectedClaimException };
var InvalidIdentityTokenException = (function (_super) {
    __extends(InvalidIdentityTokenException, _super);
    function InvalidIdentityTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidIdentityTokenException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidIdentityTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidIdentityTokenException.prototype);
        return _this;
    }
    return InvalidIdentityTokenException;
}(__BaseException));
export { InvalidIdentityTokenException };
export var AssumeRoleWithWebIdentityRequest;
(function (AssumeRoleWithWebIdentityRequest) {
    AssumeRoleWithWebIdentityRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssumeRoleWithWebIdentityRequest || (AssumeRoleWithWebIdentityRequest = {}));
export var AssumeRoleWithWebIdentityResponse;
(function (AssumeRoleWithWebIdentityResponse) {
    AssumeRoleWithWebIdentityResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssumeRoleWithWebIdentityResponse || (AssumeRoleWithWebIdentityResponse = {}));
var IDPCommunicationErrorException = (function (_super) {
    __extends(IDPCommunicationErrorException, _super);
    function IDPCommunicationErrorException(opts) {
        var _this = _super.call(this, __assign({ name: "IDPCommunicationErrorException", $fault: "client" }, opts)) || this;
        _this.name = "IDPCommunicationErrorException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, IDPCommunicationErrorException.prototype);
        return _this;
    }
    return IDPCommunicationErrorException;
}(__BaseException));
export { IDPCommunicationErrorException };
export var DecodeAuthorizationMessageRequest;
(function (DecodeAuthorizationMessageRequest) {
    DecodeAuthorizationMessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DecodeAuthorizationMessageRequest || (DecodeAuthorizationMessageRequest = {}));
export var DecodeAuthorizationMessageResponse;
(function (DecodeAuthorizationMessageResponse) {
    DecodeAuthorizationMessageResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DecodeAuthorizationMessageResponse || (DecodeAuthorizationMessageResponse = {}));
var InvalidAuthorizationMessageException = (function (_super) {
    __extends(InvalidAuthorizationMessageException, _super);
    function InvalidAuthorizationMessageException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidAuthorizationMessageException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidAuthorizationMessageException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidAuthorizationMessageException.prototype);
        return _this;
    }
    return InvalidAuthorizationMessageException;
}(__BaseException));
export { InvalidAuthorizationMessageException };
export var GetAccessKeyInfoRequest;
(function (GetAccessKeyInfoRequest) {
    GetAccessKeyInfoRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAccessKeyInfoRequest || (GetAccessKeyInfoRequest = {}));
export var GetAccessKeyInfoResponse;
(function (GetAccessKeyInfoResponse) {
    GetAccessKeyInfoResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAccessKeyInfoResponse || (GetAccessKeyInfoResponse = {}));
export var GetCallerIdentityRequest;
(function (GetCallerIdentityRequest) {
    GetCallerIdentityRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCallerIdentityRequest || (GetCallerIdentityRequest = {}));
export var GetCallerIdentityResponse;
(function (GetCallerIdentityResponse) {
    GetCallerIdentityResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCallerIdentityResponse || (GetCallerIdentityResponse = {}));
export var GetFederationTokenRequest;
(function (GetFederationTokenRequest) {
    GetFederationTokenRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFederationTokenRequest || (GetFederationTokenRequest = {}));
export var FederatedUser;
(function (FederatedUser) {
    FederatedUser.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FederatedUser || (FederatedUser = {}));
export var GetFederationTokenResponse;
(function (GetFederationTokenResponse) {
    GetFederationTokenResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFederationTokenResponse || (GetFederationTokenResponse = {}));
export var GetSessionTokenRequest;
(function (GetSessionTokenRequest) {
    GetSessionTokenRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetSessionTokenRequest || (GetSessionTokenRequest = {}));
export var GetSessionTokenResponse;
(function (GetSessionTokenResponse) {
    GetSessionTokenResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetSessionTokenResponse || (GetSessionTokenResponse = {}));
